import { render } from "./reddit.svg?vue&type=template&id=94b3cd14"
const script = {}
script.render = render

export default script